import { createSelector } from '@/factory'

import { constants } from './tooltip.constant'

const getTargets = () => createSelector<NodeListOf<HTMLElement>>({ selector: constants.selector.target }, true)

export const tooltipSelectors = {
	getTargets,
}
